//directive controller function
var NoTimeSlotControllerFunction = function ($scope) {
};
//directive controller function injections
NoTimeSlotControllerFunction.$inject = ['$scope'];
//directive link function
var NoTimeSlotLinkFunction = function ($scope, $iElement, $iAttrs) {
};
//directive link function injections
NoTimeSlotLinkFunction.$inject = ['$scope', '$element', '$attrs'];

module.exports = function () {
    return {
        replace: false,
        templateUrl: 'template/directives/no-time-slot',
        restrict: 'E',
        link: NoTimeSlotLinkFunction,
        controller: NoTimeSlotControllerFunction,
        scope: {
            showNoTimeSlot: '=?',
            appSettings: '=?'
        }
    }
};
